import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {fetchedPage, loadPage} from "../../actions/page";
import api from "../../api";
import Loader from "react-loader";
import Title from "../elements/Title";
import HeroImage from "../elements/HeroImage";
import BlockLoop from "../elements/BlockLoop";
import ContactUs from "../elements/ContactUs";
import TopBar from "../layout/TopBar";
import TopNavigation from "../navigation/TopNavigation";
import Footer from "../layout/Footer";
import SideBar from "../navigation/SideBar";

class ContactUsPage extends React.Component {
    constructor(props) {
        //IMPLEMENT OTHER JUNK HERE
        super(props)

        this.state = {
            missing: false
        }


    }
    componentWillUnmount() {
        this.props.loadPage()
    }
    componentDidMount() {
        this.props.fetchedPage('/api' + this.props.location.pathname).then(this.setState({missing: false}));
    }

    submit = data => {

        let formData = new FormData();
        formData.append('fields[formName]', data.formName);
        formData.append('fields[email]', data.email);
        formData.append('fields[subject]', data.subject);
        formData.append('fields[message]', data.message);
        formData.append('CRAFT_CSRF_TOKEN', this.props.page.CSRF);
        formData.append('action', 'guest-entries/save');
        formData.append('sectionUid', '00be4aa6-395d-4e27-86cb-767bf7d6bcc7');
        api.forms.submitForm(formData).then((data) => this.props.history.push("/thanks"));
    }

    render() {
        const {page, modal, navigation, loaded} = this.props;
        return (
          <Loader loaded={loaded}>
          <div className={"transition-item detail-page"}>
              <div className={modal.activeClass === false ? "rob" : "rob rob__blur"}>
                  <TopBar/>
                  <TopNavigation/>
                  <SideBar navigation={navigation}/>
                  <HeroImage {...page.heroImage}  />
                  <Title introTitle={page.title}/>
                  <BlockLoop/>
                  <ContactUs submit={this.submit}/>
                  <Footer/>
              </div>
          </div>
          </Loader>
        )
    };

}

ContactUsPage.defaultProps = {fields: []};

ContactUsPage.propTypes = {
    fetchedPage: PropTypes.func.isRequired
};


function mapStateToProps(state) {
    return {
        page: state.page,
        modal: state.modal,
        navigation: state.navigation,
        loaded: state.loaded.loaded
    };
}

export default connect(mapStateToProps, {fetchedPage, loadPage})(ContactUsPage);




// WEBPACK FOOTER //
// ./src/components/pages/ContactUsPage.js